import styled from '@emotion/styled';
import ImageComponent, { ImageComponentProps } from '@kyruus/image-component';

import { fromTheme } from '@kyruus/ui-theme';

export const Header = styled.h2`
  font-size: ${fromTheme('font_size_heading_5')};
`;

export const ProviderSummary = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-template-areas: 'image name' 'image specialties';
  align-items: start;
  row-gap: ${fromTheme('spacing_xsmall')};
  column-gap: ${fromTheme('spacing_medium')};
  font-size: ${fromTheme('font_size')};
  margin-bottom: ${fromTheme('spacing_large')};
`;

export const ProviderImage = styled(ImageComponent)<
  ImageComponentProps & {
    enhancementEnabled?: boolean;
  }
>`
  grid-area: image;

  flex: 0;
  display: block;
  max-height: ${({ enhancementEnabled }) =>
    enhancementEnabled ? '48px' : '40px'};
  height: auto;
  width: auto;
  border-radius: ${({ enhancementEnabled, ...rest }) =>
    enhancementEnabled
      ? fromTheme('border_radius_medium')(rest)
      : fromTheme('border_radius')(rest)};
`;
export const ProviderName = styled.div`
  grid-area: name;
  font-size: ${fromTheme('font_size_heading_5')};
`;
export const ProviderSpecialties = styled.div`
  grid-area: specialties;
`;

export const LoadingBookingOptionsMessage = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;

export const Content = styled.div`
  padding: ${fromTheme('spacing_large')};
  height: 100vh;
  overflow-y: auto;
`;

export const DrawerHeader = styled.div`
  position: sticky;
  top: 0;

  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${fromTheme('color_background')};
  border-bottom: 1px solid ${fromTheme('color_border')};
  padding: ${fromTheme('spacing_small')} ${fromTheme('spacing_large')};

  > button {
    align-self: flex-start;
  }
`;

export const Footer = styled.div`
  position: sticky;
  bottom: 0;

  background: ${fromTheme('color_background')};
  border-top: 1px solid ${fromTheme('color_border')};
  padding: ${fromTheme('spacing_medium')} ${fromTheme('spacing_large')};
`;
